import { c as _c } from "react/compiler-runtime";
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { SelectConditionalBranch } from '@/idv2/features/select-conditional-branch';
import { useFootprint } from '@/idv2/hooks/use-footprint';
import { getLogger } from '@/idv2/utils/logger';
const {
  logInfo
} = getLogger({
  name: 'idv2',
  location: 'select-conditional-branch-route'
});
export const Route = createFileRoute('/onboarding/$token/select-conditional-branch')({
  component: SelectConditionalBranchPage,
  loader: async ({
    context: {
      currentRequirement
    }
  }) => {
    if (currentRequirement?.kind !== 'select_conditional_branch') {
      throw new Error(`Invalid requirement kind: ${currentRequirement?.kind ?? 'undefined'}`);
    }
    logInfo('Select conditional branch started', {
      requirementKind: currentRequirement.kind,
      branchCount: currentRequirement.availableBranches.length
    });
    return {
      currentRequirement
    };
  }
});
export function SelectConditionalBranchPage() {
  const $ = _c(6);
  const {
    currentRequirement
  } = Route.useLoaderData();
  const footprint = useFootprint();
  const [isLoading, setIsLoading] = useState(false);
  let t0;
  if ($[0] !== footprint.navigation) {
    t0 = async chosenSuccessorId => {
      logInfo("Submitting selected conditional branch", {
        chosenSuccessorId
      });
      setIsLoading(true);
      await footprint.navigation.forward({
        chosenSuccessorId
      });
    };
    $[0] = footprint.navigation;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onSubmit = t0;
  let t1;
  if ($[2] !== currentRequirement || $[3] !== isLoading || $[4] !== onSubmit) {
    t1 = <SelectConditionalBranch isLoading={isLoading} onSubmit={onSubmit} currentRequirement={currentRequirement} />;
    $[2] = currentRequirement;
    $[3] = isLoading;
    $[4] = onSubmit;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}